export const loadPublicListings = () => import("../pages/PublicListings");
export const loadPublicDevelopments = () => import("../pages/PublicDevelopments");
export const loadPublicDevelopmentDetail = () => import("../pages/PublicDevelopments/DevelopmentDetailLanding");
export const loadPublicSimulator = () => import("../pages/PublicSimulator");
export const loadPropertyDirectLanding = () => import("../pages/PropertyDirectLanding");
export const loadClientPortalAuthPage = () => import("../pages/ClientPortal/ClientPortalAuthPage");
export const loadClientPortalAreaPage = () => import("../pages/ClientPortal/ClientPortalAreaPage");
export const loadPublicInterviewFormPage = () => import("../pages/PublicInterviewForm");
export const loadPublicInterviewUnsubscribePage = () => import("../pages/PublicInterviewUnsubscribe");

const propertyReferencePattern = /^\/[A-Za-z][A-Za-z0-9-]*[0-9][A-Za-z0-9-]*\/?$/;

export const preloadPublicRoute = pathname => {
  const normalizedPath = String(pathname || "/").replace(/\/+$/, "") || "/";

  if (["/", "/listings", "/imoveis"].includes(normalizedPath)) {
    return loadPublicListings();
  }
  if (["/lancamentos", "/empreendimentos"].includes(normalizedPath)) {
    return loadPublicDevelopments();
  }
  if (normalizedPath.startsWith("/lancamento/") || normalizedPath.startsWith("/empreendimento/")) {
    return loadPublicDevelopmentDetail();
  }
  if (normalizedPath === "/simulator") {
    return loadPublicSimulator();
  }
  if (normalizedPath.startsWith("/property/") || propertyReferencePattern.test(normalizedPath)) {
    return loadPropertyDirectLanding();
  }
  if (["/login", "/signup", "/cliente/login", "/cliente/cadastro"].includes(normalizedPath)) {
    return loadClientPortalAuthPage();
  }
  if (normalizedPath === "/cliente" || normalizedPath.startsWith("/cliente/")) {
    return loadClientPortalAreaPage();
  }
  if (normalizedPath === "/interviews/unsubscribe") {
    return loadPublicInterviewUnsubscribePage();
  }
  if (normalizedPath.startsWith("/interviews/")) {
    return loadPublicInterviewFormPage();
  }

  return loadPublicListings();
};
